import { render, staticRenderFns } from "./bonusDashboard.vue?vue&type=template&id=1a94af44&scoped=true&"
import script from "./bonusDashboard.vue?vue&type=script&lang=js&"
export * from "./bonusDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a94af44",
  null
  
)

export default component.exports